/* eslint-disable react/prop-types */

import React, { useContext } from 'react';
import {
  Container,
  Info,
  Title,
  Subtitle,
  Actions,
} from './styles';
import { DarkModeContext } from '../../common/contexts/darkMode';

function PageHeader({
  title,
  subtitle,
  actions,
}) {
  const { toggleMode } = useContext(DarkModeContext);
  return (
    <Container>
      <Info>
        <Title style={{ color: toggleMode === true ? '#fff' : '#000' }}>{title}</Title>

        {subtitle && (
          <Subtitle>{subtitle}</Subtitle>
        )}
      </Info>

      {actions && (
        <Actions>
          {actions}
        </Actions>
      )}
    </Container>
  );
}

export default PageHeader;